module.exports = __webpack_public_path__ + "img/eye-hidden.c2c205d0.svg";